import { useGetStationeryEntitiesCountForNavigationByEventIdQuery } from '../../Card.graphql.generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { isValidStationeryDraft } from '../../routes/Dashboard/components/DraftsGallery/isValidStationeryDraft';

export const useStationeryEntitiesCount = () => {
  const { eventInfo } = useEventInfo();
  const { isAdmin, fetching } = useEventUserRole();
  const isAdminStale = !isAdmin || fetching;
  const { data } = useGetStationeryEntitiesCountForNavigationByEventIdQuery({
    variables: {
      eventId: eventInfo?.eventId as string,
      eventIdString: eventInfo?.eventId as string,
    },
    batchMode: 'off',
    skip: isAdminStale || !eventInfo?.eventId,
  });

  const validDrafts = data?.stationeryDraftsCount?.filter(isValidStationeryDraft);

  const draftsCount =
    (validDrafts?.length ?? 0) +
    (data?.digitalInvitationDraft?.id ? 1 : 0) +
    (data?.digitalSaveTheDateDraft?.id ? 1 : 0) +
    (data?.digitalPhotoSaveTheDateDraft?.id ? 1 : 0) +
    (data?.digitalCustomDraft?.id ? 1 : 0);
  const favoritesCount = data?.stationeryFavoritesCount?.pagedResults?.totalCount ?? 0;
  const ordersCount = data?.stationeryOrders?.count ?? 0;

  return { draftsCount, favoritesCount, ordersCount };
};
